import { DEFAULT_SCOPE, DEFAULT_BLOCKSTACK_HOST } from './constants.esm.js';
import { getGlobalObject } from '@stacks/common';

var AppConfig = /*#__PURE__*/function () {
  function AppConfig(scopes, appDomain, redirectPath, manifestPath, coreNode, authenticatorURL) {
    if (scopes === void 0) {
      scopes = DEFAULT_SCOPE.slice();
    }

    if (appDomain === void 0) {
      var _getGlobalObject;

      appDomain = (_getGlobalObject = getGlobalObject('location', {
        returnEmptyObject: true
      })) == null ? void 0 : _getGlobalObject.origin;
    }

    if (redirectPath === void 0) {
      redirectPath = '';
    }

    if (manifestPath === void 0) {
      manifestPath = '/manifest.json';
    }

    if (coreNode === void 0) {
      coreNode = undefined;
    }

    if (authenticatorURL === void 0) {
      authenticatorURL = DEFAULT_BLOCKSTACK_HOST;
    }

    this.appDomain = appDomain;
    this.scopes = scopes;
    this.redirectPath = redirectPath;
    this.manifestPath = manifestPath;
    this.coreNode = coreNode;
    this.authenticatorURL = authenticatorURL;
  }

  var _proto = AppConfig.prototype;

  _proto.redirectURI = function redirectURI() {
    return "" + this.appDomain + this.redirectPath;
  };

  _proto.manifestURI = function manifestURI() {
    return "" + this.appDomain + this.manifestPath;
  };

  return AppConfig;
}();

export { AppConfig };
//# sourceMappingURL=appConfig.esm.js.map
